export default "https://cdn-static.gokick.com/assets/5a032fdfc840f3d1fce44ec205c52ed2ca8e0677/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";